var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("table", [
        _vm._m(0),
        _vm._m(1),
        _c(
          "tbody",
          [
            _vm._l(_vm.cbtList, function (roomCBT) {
              return _c("tr", { key: roomCBT.roomCBTId }, [
                _c("td", [_vm._v(_vm._s(roomCBT.cbtTitle))]),
                _c("td", [_vm._v(_vm._s(roomCBT.questionCnt))]),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "flex justify-center items-center gap-1" },
                    [
                      _c(
                        "GrmBtn",
                        {
                          attrs: { size: "xs" },
                          on: {
                            click: function ($event) {
                              return _vm.onSelectCBT(roomCBT)
                            },
                          },
                        },
                        [_vm._v("상세보기")]
                      ),
                      _c(
                        "GrmBtn",
                        {
                          attrs: { size: "xs", color: "red" },
                          on: {
                            click: function ($event) {
                              return _vm.onDeleteCBT(roomCBT)
                            },
                          },
                        },
                        [_vm._v("삭제")]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            }),
            _vm.cbtList.length === 0
              ? _c("tr", [
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v("문제집이 없습니다."),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("GrmPagination", {
        staticClass: "mt-3",
        attrs: { "page-info": _vm.cbtListPageInfo },
        on: { paging: _vm.onChangePage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "8" } }),
      _c("col", { attrs: { width: "1" } }),
      _c("col", { attrs: { width: "2" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("제목")]),
        _c("th", [_vm._v("문항 수")]),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }